import React from 'react';
import Banner from 'ui/Banner/Banner';
import ImgBlock from 'ui/ImgBlock/ImgBlock';
import IFrame from 'ui/IFrame/IFrame';
import Raw from 'ui/Raw/Raw';

const LocationContent = ({continents, location}) => {
    const {
        title,
        body,
        bgImageUrl,
        images,
        paragraph,
        videoTitle,
        videoUrl,
    } = continents
        .map((continent) => continent.offices)
        .map((office) => office)
        .reduce((acc, val) => acc.concat(val), [])
        .filter((item) => item.filter === location)[0];

    return (
        <section className="careers-location">
            <Banner image={bgImageUrl}>
                <h2 className="text-white">{title}</h2>
                <p>{body}</p>
            </Banner>
            <div className="container container--overlap container--flush">
                <ImgBlock images={images} />
            </div>
            <div className="container location-video">
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <IFrame src={videoUrl} />
                    </div>
                    <div className="col-xs-12 col-sm-5">
                        <h3>{videoTitle}</h3>
                        <Raw content={paragraph} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationContent;
